import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/google.png'
import _imports_1 from '@/assets/images/border-3.png'
import _imports_2 from '@/assets/images/shape-10.png'


const _hoisted_1 = { class: "who-we-area pt-100 overflow-hidden bg-gondola2 position-relative z-1" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = {
  class: "row",
  "data-cues": "zoomOut"
}
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "who-we-area-content" }
const _hoisted_6 = { class: "top-title" }
const _hoisted_7 = { class: "text-white" }
const _hoisted_8 = { class: "row align-items-center" }
const _hoisted_9 = { class: "col-lg-9" }
const _hoisted_10 = { class: "ps-0 list-unstyled we-are-list" }
const _hoisted_11 = { class: "col-lg-3" }
const _hoisted_12 = { class: "google" }
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "who-we-img-wrap" }
const _hoisted_15 = { class: "row align-items-end" }
const _hoisted_16 = { class: "col-lg-6 col-sm-6" }
const _hoisted_17 = { class: "who-we-1 who-we-img" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = { class: "review mb-minus-53" }
const _hoisted_21 = { class: "review-in" }
const _hoisted_22 = { class: "stat-figure" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "review bg-golden" }
const _hoisted_25 = { class: "review-in" }
const _hoisted_26 = { class: "stat-figure" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "col-lg-6 col-sm-6" }
const _hoisted_29 = { class: "who-we-2 who-we-img" }
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.c.top_title), 1),
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.c.title), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.c.description), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c.bullet_points, (point, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(point), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[2] || (_cache[2] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: "google"
                  }, null, -1)),
                  _createElementVNode("p", null, [
                    _cache[1] || (_cache[1] = _createTextVNode("Ratings ")),
                    _createElementVNode("span", null, _toDisplayString(_ctx.c.rating), 1)
                  ])
                ])
              ])
            ]),
            _createVNode(_component_RouterLink, {
              to: "/pricing",
              class: "btn"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "border-style" }, "Subscribe Now", -1)
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.c.stat_reviews_label), 1),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.c.stat_reviews), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.c.stat_subscriptions_label), 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.c.stat_subscriptions), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("img", {
                    src: _ctx.c.image_1_url || _ctx.whoWe1,
                    alt: "who-we"
                  }, null, 8, _hoisted_27)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("img", {
                    src: _ctx.c.image_2_url || _ctx.whoWe2,
                    alt: "who-we"
                  }, null, 8, _hoisted_30)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_1,
      class: "border-3",
      alt: "border"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: _imports_2,
      class: "shape shape-10",
      alt: "shape"
    }, null, -1))
  ]))
}